export default __webpack_public_path__ + "static/media/pic5.91eb6f43.jpg";